import React, { FC } from 'react';

const SelectableProfileFundAllocation: FC<{
    fundAllocationPercentage?: number;
}> = ({ fundAllocationPercentage }) =>
    fundAllocationPercentage ? (
        <article>
            {fundAllocationPercentage < 100
                ? `${fundAllocationPercentage}\u00A0%\u00A0aksjefond, ${100 - fundAllocationPercentage}\u00A0%\u00A0rentefond`
                : '100\u00A0%\u00A0aksjefond.'}
        </article>
    ) : null;

export default SelectableProfileFundAllocation;